<template>
  <div>
    <FITFormCard>
      <b-row slot="header" align-v="center">
        <b-col>
          <h5><i class="fa fa-file mr-2"></i>{{$t('osm.contents.lifePolicy.generalInformation.riders.title')}}</h5></b-col>
      </b-row>
      <div slot="formBody">
        <template v-for="(item,idx) in oldRiderList">
          <ExistedRiderRow class="my-2" :index="idx" :riderDetail="item" :bus="bus"></ExistedRiderRow>
        </template>
        <!-- <template v-for="n in riderNumbers"> -->
        <RiderRow v-if="permissionLevel < 3.5" :index="1 + oldRiderList.length" :bus="bus"></RiderRow>
        <!-- </template> -->
        <b-alert :show="addRiderAlertCd" dismissible variant="success" @dismissed="addRiderAlertCd=0">{{$t('general.updateSuccess')}}</b-alert>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITTextInput, FITSelect, FITAutoSearch, FITModal } from '@/components'
import { mapState, mapGetters } from 'vuex'
import RiderRow from './RiderRow'
import ExistedRiderRow from './ExistedRiderRow'
import Vue from 'vue'
export default {
  name: 'NewLifePolicyRider',
  computed: {
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    ...mapState({
      workflowCurrentIndex: state => state.LifePolicy.newLife.workflowCurrentStep,
      policyID: state => state.LifePolicy.newLife.policyID,
      vuexOldRiderList: state => state.LifePolicy.newLife.lifeGeneralInfo.riders,
    }),
    ...mapGetters("LifePolicy", [
      'getTranslatedPolicyFields'
    ]),
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    vuexOldRiderList(newData, oldData) {
      console.debug(newData);
      Vue.set(this, 'oldRiderList', JSON.parse(JSON.stringify(newData)));
    }
  },

  created() {
    this.bus.$on('removeRiderSuccess', (index) => {
      console.debug(index);
      var copy = JSON.parse(JSON.stringify(this.oldRiderList));
      console.debug(copy);
      copy.splice(index, 1);
      Vue.set(this, 'oldRiderList', copy);
      this.$store.commit({ type: 'LifePolicy/setRider', riders: copy });
      this.showRiderAlert();
      // console.debug(copy);
    });

    this.bus.$on('addRiderSuccess', (obj) => {
      // console.log("create: ");
      // console.log(obj);
      this.oldRiderList.push(obj);
      this.$store.commit({ type: 'LifePolicy/setRider', riders: this.oldRiderList });
      this.showRiderAlert();
    })
  },
  methods: {
    saveToVuex() {
      console.debug('saved to vuex ======')
      this.$store.commit({ type: 'LifePolicy/setRider', riders: this.oldRiderList });
    },
    showRiderAlert() {
      this.addRiderAlertCd = this.dismissSecs;
    }
  },
  data() {
    return {
      oldRiderList: [],
      riderNumbers: 1,
      bus: new Vue,
      addRiderAlertCd: 0,
      dismissSecs: 3,
      totalRiders: this.riderNumbers,
      riderInfo: {},
      selectedProduct: { ID: -1 },
      productAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: "life" }],
        showItems: ['productEnglishName', 'productChineseName'],
      },
      notificationContent: this.$t('osm.contents.general.addRiderConfirm'),
    }
  },
  components: {
    FITFormCard,
    FITTextInput,
    FITSelect,
    FITAutoSearch,
    FITModal,
    RiderRow,
    ExistedRiderRow
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/NewLifePolicy/NewLifePolicyRiders.vue